import { JSX } from "react";
import { toast } from "react-toastify";

function toastReportQueued(reportName: string, redirectOnDismiss: () => void): void {
  toast.info(
    <ReportQueuedToastBody reportName={reportName} />,
    {
      closeOnClick: true,
      containerId: "z-index-9999",
      draggable: false,
      onClose: () => {
        redirectOnDismiss();
      },
    });
}

function ReportQueuedToastBody(props: { reportName: string }): JSX.Element {
  return (
    <span>{props.reportName || "Requested report"} < br /> has been queued for generation. Please check < br /> email / Exception Reports page for status.</span>
  );
}

export {
  toastReportQueued as toastInfo,
};